/**
 *
 * TopicItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useAlgoliaLocale from 'components/useAlgoliaLocale';
import { useEmbedlyImage, handleEmbedlyImageError } from 'utils/embedlyUtils';
import { getAlgoliaLocalizedField } from 'utils/localeUtils';

const useStyles = makeStyles({
  link: {
    display: 'block',
    textDecoration: 'none',
    position: 'relative',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    height: 60,
    width: 60,
    marginRight: 12,
    objectFit: 'cover',
  },
  title: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px',
    display: '-webkit-box',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 54 /* Fallback for non-webkit */,
    width: 'calc(100% - 72px)',
  },
});

const TopicItem = ({ data, onClick, variantELocale, topicSource }) => {
  const classes = useStyles();
  const locale = useAlgoliaLocale();
  const imageUrl = data?.imageUrl;
  const imgSrc = useEmbedlyImage(imageUrl);

  if (_isEmpty(data)) return null;

  const { url, nameTitle } = data;
  const lang = variantELocale || locale;
  const to = topicSource
    ? {
        pathname: url.split('?')[0],
        search: `?lang=${lang}`,
        state: { topicSource },
      }
    : `${url}?lang=${lang}`;

  const handleClick = () => {
    onClick({
      type: 'Topics',
      name: nameTitle,
      entryId: data.objectID,
    });
  };
  return (
    <Link to={to} className={classes.link} onClick={handleClick}>
      <div className={classes.wrapper}>
        <img
          src={imgSrc}
          alt=""
          className={classes.image}
          onError={e => handleEmbedlyImageError(e, imageUrl)}
        />
        <Typography color="textPrimary" className={classes.title}>
          {getAlgoliaLocalizedField(
            data,
            'nameTitle',
            variantELocale || locale,
          )}
        </Typography>
      </div>
    </Link>
  );
};

TopicItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  topicSource: PropTypes.string,
};

export default TopicItem;
